<template>
  <div class="navbar">
    <div>
      <hamburger
        id="hamburger-container"
        :is-active="sidebar.opened"
        class="hamburger-container"
        @toggleClick="toggleSideBar"
      />

      <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    </div>

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <!-- <search id="header-search" class="right-menu-item" /> -->

        <!-- <error-log class="errLog-container right-menu-item hover-effect" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" /> -->
        <!--
        <el-tooltip :content="$t('navbar.size')" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item  hover-effect" />
        </el-tooltip> -->

        <!-- <lang-select class="right-menu-item hover-effect" /> -->
      </template>
      <div style="margin-right: 6px">
        <router-link to="/messageNotification/index">
          <el-badge
            v-if="badgeCount > 0"
            :value="badgeCount"
            :max="99"
            style="margin-right: 24px; cursor: pointer"
          >
            <img src="/ops.svg">
          </el-badge>
          <img
            v-else
            src="/ops.svg"
            style="margin-right: 24px; cursor: pointer"
          >
        </router-link>
        <img src="/set.svg">
      </div>

      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <el-divider direction="vertical" />
          <div>
            <img
              :src="'http://ad-ziyou.jingxuansz.com/img/larke.a37c4b81.png'"
              class="user-avatar"
            >
            <span style="color: #1d2129; margin-left: 7px; font-size: 14px">{{
              userIfon.nickname
            }}</span>
            <i class="el-icon-caret-bottom" />
          </div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/profile/index">
            <el-dropdown-item>
              {{ $t('navbar.profile') }}
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item @click.native="clearCache">
            {{ $t('清空缓存') }}
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">{{ $t('navbar.logOut') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
// import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
// import LangSelect from '@/components/LangSelect'
// import Search from '@/components/HeaderSearch'
import { clearCache } from '@/api/system'
import { getInfo } from '@/api/user'
import { notificationStatistics } from '@/api/notify'

export default {
  components: {
    Breadcrumb,
    Hamburger
    // ErrorLog,
    // Screenfull,
    // SizeSelect,
    // LangSelect,
    // Search
  },
  data() {
    return {
      userIfon: {},
      badgeCount: 0
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device'])
  },
  created() {
    getInfo().then((data) => {
      this.userIfon = data.data
    })
    window.login = this
    this.fetchBadgeCount()
  },
  mounted() {
    // A) 监听本 Tab 的 window 自定义事件
    this.__onNotifyChanged = () => {
      // 简单防抖：避免极短时间多次调用（可选）
      clearTimeout(this.__notifyTimer)
      this.__notifyTimer = setTimeout(() => this.fetchBadgeCount(), 200)
    }
    window.addEventListener('notify:changed', this.__onNotifyChanged)

    // B) 监听跨 Tab 的 storage 事件
    this.__onNotifyStorage = (e) => {
      if (e.key === 'NOTIFY_CHANGED') {
        clearTimeout(this.__notifyTimer)
        this.__notifyTimer = setTimeout(() => this.fetchBadgeCount(), 200)
      }
    }
    window.addEventListener('storage', this.__onNotifyStorage)
  },
  beforeDestroy() {
    window.removeEventListener('notify:changed', this.__onNotifyChanged)
    window.removeEventListener('storage', this.__onNotifyStorage)
    clearTimeout(this.__notifyTimer)
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    clearCache() {
      const thiz = this
      clearCache().then((res) => {
        if (res.code === 0) {
          this.$message({
            message: thiz.$t('清空网站缓存成功'),
            type: 'success',
            duration: 3 * 1000
          })
        }
      })
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    async fetchBadgeCount() {
      try {
        const res = await notificationStatistics()
        const stats = res?.data || []
        // type=0 就是全部
        const total = stats.find((s) => String(s.type) === '0')
        this.badgeCount = total ? total.unread_total || 0 : 0
      } catch (e) {
        this.badgeCount = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 64px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        position: relative;
        display: flex;
        align-items: center;

        .user-avatar {
          cursor: pointer;
          width: 25px;
          height: 25px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -18px;
          top: 21px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
